import { objectToArray } from '../helpers';

const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addDistributes: ({ commit }, distributes) => {
    objectToArray(distributes).forEach(d => {
      commit('add', d);
    });
  }
};

const mutations = {
  add: (state, distribute) => {
    state.byId[distribute.id] = distribute;
    if (state.allIds.includes(distribute.id)) return;
    state.allIds.push(distribute.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
